import { render, staticRenderFns } from "./CouponCarouselSingleView.vue?vue&type=template&id=1109ca91&scoped=true&"
import script from "./CouponCarouselSingleView.vue?vue&type=script&lang=js&"
export * from "./CouponCarouselSingleView.vue?vue&type=script&lang=js&"
import style0 from "./CouponCarouselSingleView.vue?vue&type=style&index=0&id=1109ca91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1109ca91",
  null
  
)

export default component.exports